import React from 'react';
import PropTypes from 'prop-types';
import { toLower, includes } from 'lodash';
import { LowQuality, GoodQuality, HighQuality } from './styled';
import { LOW_QUALITY, GOOD_QUALITY, HIGH_QUALITY } from './constants';

/**
 * Feedback
 * @param type {string}
 * @returns {JSX.Element}
 */
const Feedback = ({ type = 'Low Quality' }) => {
  const feedbackType = toLower(type);
  return (
    <>
      {includes(['low quality', 'low'], feedbackType) && (
        <LowQuality>{LOW_QUALITY}</LowQuality>
      )}
      {includes(['good quality', 'good'], feedbackType) && (
        <GoodQuality>{GOOD_QUALITY}</GoodQuality>
      )}
      {includes(['high quality', 'high'], feedbackType) && (
        <HighQuality>{HIGH_QUALITY}</HighQuality>
      )}
      {feedbackType === '-' && <>{feedbackType}</>}
    </>
  );
};

Feedback.propTypes = {
  type: PropTypes.string
};

export default Feedback;
